// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileNavTab_wrapper__3VKeL","opening":"MobileNavTab_opening__KhvAg","tabLabel":"MobileNavTab_tabLabel__Juu57"};